import { func, number, oneOfType, string } from 'prop-types';
import React from 'react';
import FormBox from '../../components/Form/FormBox';
import PageTitle from '../../components/PageTitle';
import TextField from '../../components/TextField';
import FormHOC from '../../features/HOC/FormHOC';
import InfoBox from '../../components/InfoBox';

function SwapReason({ submitForm, index, approvalStatus, ...rest }) {
  const form = [
    {
      title: 'Skäl',
      id: 'freeText',
      name: 'freeText',
      description:
        'Beskriv ditt/dina beaktansvärda skäl. Fältet är begränsat till max 250 tecken.',
      placeholder:
        'T.ex. bytesförfrågan sker på grund av ändrad familjesituation.',
      maxLength: 250,
      rows: 5,
      component: TextField,
    },
  ];

  return (
    <div>
      <PageTitle>Skäl till bytet</PageTitle>
      <InfoBox header="Läs detta först">
        <span>
          För att ha rätt att byta din lägenhet krävs i enlighet med hyreslagen
          ett så kallat ”beaktansvärt skäl”. Det vill säga ett behov av att byta
          sin lägenhet. Exempel på detta kan vara att man är i behov av lägre
          hyra i och med en förändrad ekonomisk situation, ett rum extra till
          barnen som blivit större eller arbete/studier på annan ort. Det finns
          naturligtvis en mängd olika skäl till varför man behöver byta sin
          bostad och på hyresnämndens hemsida kan du läsa mer om vad som gäller
          vid byte av din bostad om du känner dig osäker.
          <br />
          <br />
          <strong>
            OBS: Skälet som anges måste alltid kunna styrkas. T.ex. så ska ett
            havandeskapsintyg kunna uppvisas om skälet är tillökning i familjen.
          </strong>
          <br />
          <br />
          Länk till hyresnämnden:{' '}
          <a
            href="http://www.hyresnamnden.se/Byta-och-overlata-lagenhet/Forutsattningar/"
            target="_blank"
            rel="noopener noreferrer">
            http://www.hyresnamnden.se/Byta-och-overlata-lagenhet/Forutsattningar/
          </a>
        </span>
      </InfoBox>
      <FormBox
        form={form}
        handleClick={(e) => submitForm(e, index)}
        status={approvalStatus}
        {...rest}
      />
    </div>
  );
}

SwapReason.propTypes = {
  submitForm: func.isRequired,
  index: oneOfType([string, number]).isRequired,
};

export default FormHOC(SwapReason, {
  form: 'swapReason',
});



// WEBPACK FOOTER //
// ./src/views/SwapReason/index.js